module.exports = __webpack_public_path__ + "img/qdyjcg.db9dee12.png";